import { render, staticRenderFns } from "./AccountPhone.vue?vue&type=template&id=67b92e26&scoped=true&"
import script from "./AccountPhone.vue?vue&type=script&lang=js&"
export * from "./AccountPhone.vue?vue&type=script&lang=js&"
import style0 from "./AccountPhone.vue?vue&type=style&index=0&id=67b92e26&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b92e26",
  null
  
)

export default component.exports